var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDrawing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Graphic-Tablet-Drawing-Pen--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Graphic Tablet Drawing Pen Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.19 16.56a0.5 0.5 0 0 0 -0.81 0.17L0.76 20.67a2 2 0 0 0 -0.09 1.25l-0.38 0.37a1 1 0 0 0 1.42 1.42l0.38 -0.38a1.91 1.91 0 0 0 1.24 -0.09l3.94 -1.62a0.5 0.5 0 0 0 0.17 -0.81Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.27 2.15 21.85 0.73a2.5 2.5 0 0 0 -3.53 0l-1.06 1.06a0.5 0.5 0 0 0 0 0.71l4.24 4.24a0.5 0.5 0 0 0 0.71 0l1.06 -1.06a2.5 2.5 0 0 0 0 -3.53Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 3.46a0.51 0.51 0 0 0 -0.71 0L4.15 14.9a0.51 0.51 0 0 0 0 0.71l4.24 4.24a0.5 0.5 0 0 0 0.71 0L20.54 8.41a0.5 0.5 0 0 0 0 -0.71Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDrawing);
export default ForwardRef;